import React, { memo } from 'react'

import { StyledTitle } from './styled'

const Title = ({ children }) => <StyledTitle> {children} </StyledTitle>

export default memo(Title)
